'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagMaAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M0 8.88109e-06C9.33333 -8.36891e-05 18.6667 0 28 0C28 6.66667 28 13.3333 28 20C18.6667 20 9.33333 20 0 20V8.88109e-06Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M0 8.88109e-06L28 0V20H0V8.88109e-06Z", fill: "#E33B44" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14 10.7026L15.0589 11.4574L14.6682 10.2171L15.7133 9.44333L14.413 9.43162L14 8.19858L13.587 9.43162L12.2867 9.44333L13.3318 10.2171L12.9411 11.4574L14 10.7026ZM10.4733 14.8541L11.7745 10.7231L8.29366 8.1459L12.6246 8.1069L14 4L15.3754 8.1069L19.7063 8.1459L16.2255 10.7231L17.5267 14.8541L14 12.34L10.4733 14.8541Z",
          fill: "#0A6135"
        }
      )
    ]
  }
);
const VpFlagMaAsset = forwardRef(FlagMaAsset);

export { VpFlagMaAsset as default };
